export class DbInfo {
	id:number;
	nickname:string;

	public constructor(data:any) {
		this.id = data.id;
		this.nickname = data.nickname;
	}

	toString():string {
		if (this.nickname) {
			return `${this.nickname} (Database ${this.id + 1})`;
		}
		return `Database ${this.id + 1}`;
	}
}